import { FeatureToggleBuilder, AvailableDeploymentLevels } from '@mojility/coach-core';
import Features from '../../features';

function buildFeatureToggles(coachBrowserDomGateway) {
  // console.log("FeatureSet", Features);
  return FeatureToggleBuilder.buildInBrowser(Features, AvailableDeploymentLevels, coachBrowserDomGateway);
}

export default {
  name: 'featureToggles',
  fn: buildFeatureToggles
}